module.exports = __webpack_public_path__ + "media/images/star-c73e6b28689100b8b40fe334cafe9f8f.svg";